import * as React from "react";
const SvgDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.41 16L20 20.58L24.59 16L26 17.41L20 23.41L14 17.41L15.41 16Z", fill: "#0B4566" }));
export default SvgDown;
